import UserIconLight from '@Resources/assets/icons/dark/user.svg';
import UserIconDark from '@Resources/assets/icons/light/user.svg';
import { stopBubbling } from '@Utils/helpers/eventHelpers';
import { useAuth0 } from '@auth0/auth0-react';
import { Divider, Menu, MenuItem, SvgIcon, Tooltip } from '@mui/material';
import React, { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ISettingsProps } from '@Components/Header/Interfaces';
import Styles from '@Components/IconButton/IconButton.scss';
import {
    UserAvatarButton,
    UserAvatarButtonSize,
} from '@Components/IconButton/index';
import { SettingsType } from '@Components/Settings/SettingsType';

const UserMenu = (props: ISettingsProps) => {
    const { onSettingsBtnClick } = props;
    const { user, logout } = useAuth0();
    const username = user.email;
    const userMenuBtnId = 'koru-user-menu-btn';
    const [open, setIsOpen] = useState<boolean>(false);

    const handleLogOut = () => {
        logout({
            logoutParams: {
                returnTo: `${process.env.BASE_URI}login`,
            },
        });
    };

    const toggleMenu = (e) => {
        stopBubbling(e);
        setIsOpen(!open);
    };

    return (
        <React.Fragment>
            <Tooltip title="My Profile">
                <div className={Styles.iconButtonWrapper}>
                    <UserAvatarButton
                        id={userMenuBtnId}
                        onClick={toggleMenu}
                        isSelected={open}
                        disabled={props.isSubmitting}
                        size={UserAvatarButtonSize.SMALL}
                        pictureUrl={user.picture}
                        defaultIcon={
                            <SvgIcon inheritViewBox>
                                {open ? <UserIconDark /> : <UserIconLight />}
                            </SvgIcon>
                        }
                    />
                </div>
            </Tooltip>
            <Menu
                open={open}
                onClose={toggleMenu}
                anchorEl={document.getElementById(userMenuBtnId)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                keepMounted
            >
                <MenuItem id="user-menu-item-username" disabled dense>
                    <span>{username}</span>
                </MenuItem>
                <Divider />
                <MenuItem
                    id="user-menu-item-settings"
                    onClick={() => onSettingsBtnClick(SettingsType.PROFILE)}
                    dense
                >
                    Settings
                </MenuItem>
                <Divider />
                <MenuItem
                    id="user-menu-item-logout"
                    onClick={handleLogOut}
                    dense
                >
                    Log out
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default memo(UserMenu);
